export const QUEUE_STATUS = {
    0: { name: "Pending", background: "warning" },
    1: { name: "Success", background: "success" },
    2: { name: "Failed", background: "danger" },
}